import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
    boxShadow: '0 3px 5px 2px rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    padding: '8px 16px',
    '&:hover': {
        boxShadow: '0 4px 8px 2px rgba(0, 0, 0, 0.15)',
    },
}));

const ElevatedButton = ({ children, ...props }) => {
    return (
        <StyledButton {...props}>
            {children}
        </StyledButton>
    );
};

export default ElevatedButton; 